import { Injectable } from '@angular/core';
import * as JSLZString from 'lz-string';

@Injectable()
export class Util {

    public ocorrenciaAlterada: String = '';

    public converteData(data: Date) : Date
    {
        let dt = new Date(data);
        return new Date(dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset()));
    }

    compress(data: string) {
      return JSLZString.compressToEncodedURIComponent(data);
    }
  
    decompress(data: string){
      return JSLZString.decompressFromEncodedURIComponent(data);
    }

    
    trataNameArquivo(name: string, tamanho): string {
      const tamanhoMaximo = tamanho;
      if (name.length > tamanhoMaximo) {
        return name.substring(0, tamanhoMaximo - 4) + '...' + name.substring(name.length - 10);
      } else {
        return name;
      }
    } 
      
    expirouTempo(horas: number, dataEnvio: string ){
      const dataString = dataEnvio.replace('Z', '')
      const data = new Date(dataString);
      const tempoData = data.getTime();
      const tempoAtual = Date.now();
      const passouHoras = (tempoAtual - tempoData) > (horas * 60 * 60 * 1000);
      return passouHoras
    }

    public converterDataSemFuso(data: Date) : string
    {
        let date = new Date(data);
        let year = date.getUTCFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();

        let monthAux = (month < 10) ? '0' + month : month;
        let dayAux = (day < 10) ? '0' + day : day;
        let hoursAux = (hours < 10) ? '0' + hours : hours;
        let minutesAux = (minutes < 10) ? '0' + minutes : minutes;
        let secondsAux = (seconds < 10) ? '0' + seconds : seconds;

        return year + '-' + monthAux + '-' + dayAux + ' ' + hoursAux + ':' + minutesAux + ':' + secondsAux;
    }  
    
    static calcularDistanciaGeo(lat1: number, lon1: number, lat2: number, lon2: number): number {
      const R: number = 6371; 
      const dLat: number = this.deg2rad(lat2 - lat1);
      const dLon: number = this.deg2rad(lon2 - lon1);
  
      const a: number = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                        Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
                        Math.sin(dLon / 2) * Math.sin(dLon / 2);
  
      const c: number = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const d: number = R * c; 
      return d * 1000;
    }
  
    static deg2rad(deg: number): number {
        return deg * (Math.PI / 180);
    }

    

}
export enum TipoOcorrenciaEspecial{
    SANEAMENTO_CLIENTE = "SANEAMENTO CLIENTE",
    CUSTO_EXTRA = "CUSTO EXTRA",
    HORARIO_RECEBIMENTO = "HORARIO RECEBIMENTO",

}

export enum SituacaoOcorrenciaEspecial{
    Aberto = "AB",
    Encerrado = "EN",
    Cancelado = "CA"
}

export enum IdOrigemMensagem  {
    Motorista = 0,  
    Distribuidora = 1
}